export const fileErrorMessages = {
  FILE_SIZE: 'files.fileTooLarge',
  FILE_TYPE: 'files.fileTypeNotSupported',
  TIMEOUT: 'files.uploadTimeout',
  NETWORK: 'files.connectionError',
  SERVER: 'files.serverError',
  GENERAL: 'files.generalError',
};

export const fileErrorEvents = {
  PAYLOAD_TOO_LARGE: 'PAYLOAD_TOO_LARGE',
  ATTACHMENT_TYPE_ERROR: 'ATTACHMENT_TYPE_ERROR',
  ATTACHMENT_SCAN_ERROR: 'ATTACHMENT_SCAN_ERROR',
  ATTACHMENT_UPLOAD_TIMEOUT_ERROR: 'ATTACHMENT_UPLOAD_TIMEOUT_ERROR',
  ATTACHMENT_ERROR: 'ATTACHMENT_ERROR',
  ERROR_NETWORK: 'ERR_NETWORK',
};

export const fileErrors = {
  [fileErrorEvents.PAYLOAD_TOO_LARGE]: fileErrorMessages.FILE_SIZE,
  [fileErrorEvents.ATTACHMENT_TYPE_ERROR]: fileErrorMessages.FILE_TYPE,
  [fileErrorEvents.ATTACHMENT_SCAN_ERROR]: fileErrorMessages.GENERAL,
  [fileErrorEvents.ATTACHMENT_UPLOAD_TIMEOUT_ERROR]: fileErrorMessages.TIMEOUT,
  [fileErrorEvents.ATTACHMENT_ERROR]: fileErrorMessages.SERVER,
  [fileErrorEvents.ERROR_NETWORK]: fileErrorMessages.NETWORK,
};

export const fileErrorsToResend = [
  fileErrorMessages.GENERAL,
  fileErrorMessages.NETWORK,
  fileErrorMessages.SERVER,
  fileErrorMessages.TIMEOUT,
];
